var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 377.81 354.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff0b00;}.cls-2{opacity:.45;}.cls-2,.cls-3,.cls-4{fill:#bca58e;}.cls-3{opacity:.09;}.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12{stroke-miterlimit:10;}.cls-5,.cls-6,.cls-8,.cls-9,.cls-11{stroke:#bca58e;}.cls-5,.cls-7,.cls-10,.cls-11,.cls-12{fill:none;}.cls-6{fill:#02a2cb;}.cls-13,.cls-8{fill:#4b0263;}.cls-7,.cls-11{stroke-width:2px;}.cls-7,.cls-12{stroke:#310000;}.cls-14,.cls-15{fill:#310000;}.cls-16,.cls-9{fill:#fcb610;}.cls-17{letter-spacing:0em;}.cls-18{fill:#fdf6e6;opacity:.2;}.cls-10{stroke:#febb09;}.cls-19{letter-spacing:0em;}.cls-20{letter-spacing:0em;}.cls-21{fill:#010305;}.cls-15{font-family:Montserrat-SemiBold, Montserrat;font-size:37.03px;font-weight:600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(90.63 318.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GRA"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 83.39,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 109.91,
    y: 0
  }, "HI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 151.71,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 178.48,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 237.45,
    y: 348.24,
    width: 32.12,
    height: 1.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237.85,352.34h-6.61v-6.61h6.61v6.61ZM232.83,350.75h3.44v-3.44h-3.44v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.39,352.34h-6.61v-6.61h6.61v6.61ZM270.36,350.75h3.44v-3.44h-3.44v3.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 248.08,
    y: 343.79,
    width: 10.48,
    height: 10.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 111.66,
    y: 348.24,
    width: 32.12,
    height: 1.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.06,352.34h-6.61v-6.61h6.61v6.61ZM107.03,350.75h3.44v-3.44h-3.44v3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.59,352.34h-6.61v-6.61h6.61v6.61ZM144.57,350.75h3.44v-3.44h-3.44v3.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 122.28,
    y: 343.79,
    width: 10.48,
    height: 10.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "122.44 17.15 43.27 139.51 201.6 138.2 122.44 17.15"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 129.12,
    cy: 186.33,
    r: 52.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 178.76,
    y: 67.79,
    width: 146.44,
    height: 136.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 236.9,
    y: 38.7,
    width: 122.66,
    height: 114.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M285.6,211.76c0,10.86-8.8,19.66-19.66,19.66s-19.66-8.8-19.66-19.66,8.8-19.66,19.66-19.66,19.66,8.8,19.66,19.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M265.74,186.33v24.51c0,2.46,0,4.93,0,7.39v16.89c0,.66-.01,1.33,0,1.99,0,.03,0,.06,0,.09,0,.98,1.53.99,1.53,0v-38.79c0-1.94,0-3.88,0-5.82v-4.17c0-.66.01-1.33,0-1.99,0-.03,0-.06,0-.09,0-.98-1.53-.99-1.53,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M291.93,210.99h-31.9c-2.3,0-4.6,0-6.89,0h-10c-.66,0-1.33-.01-1.99,0-.03,0-.06,0-.09,0-.98,0-.99,1.53,0,1.53h24.51c2.46,0,4.93,0,7.39,0h6.89c1.94,0,3.88,0,5.82,0h4.17c.66,0,1.33.01,1.99,0,.03,0,.06,0,.09,0,.98,0,.99-1.53,0-1.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.92,172.67c-7.3,0-13.24-5.94-13.24-13.24s5.94-13.24,13.24-13.24,13.24,5.94,13.24,13.24-5.94,13.24-13.24,13.24ZM30.92,146.85c-6.94,0-12.58,5.64-12.58,12.58s5.64,12.58,12.58,12.58,12.58-5.64,12.58-12.58-5.64-12.58-12.58-12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M30.78,142.73v32.04c0,.43,0,.87,0,1.3,0,.02,0,.04,0,.06,0,.65,1.01.65,1.01,0v-32.04c0-.43,0-.87,0-1.3,0-.02,0-.04,0-.06,0-.65-1.01-.65-1.01,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M47.99,158.93H15.95c-.43,0-.87,0-1.3,0-.02,0-.04,0-.06,0-.65,0-.65,1.01,0,1.01h32.04c.43,0,.87,0,1.3,0,.02,0,.04,0,.06,0,.65,0,.65-1.01,0-1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M286.79,25.99h31.4c2.12,0,3.93,1.52,4.3,3.6l2.31,12.87c1.3,7.21,7.57,12.45,14.89,12.45h0l-1.36-30.23c-.25-5.59-4.85-9.99-10.45-9.99h-102.81c-5.9,0-10.76,4.65-11.03,10.55l-1.33,29.67h0c7.32,0,13.6-5.25,14.89-12.45l2.43-13.51c.31-1.71,1.8-2.96,3.54-2.96h32.04c.4,19.57.42,39.23.42,58.75v11.3c0,19.75-.02,39.33-.42,58.51l-14.32,1.53c-5.11.55-8.99,4.86-8.99,10h67.78c0-5.14-3.88-9.45-8.99-10l-14.32-1.53c-.39-19.49-.42-39.07-.42-58.51v-11.3c0-19.84.02-39.49.42-58.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.32,194.07h-51.78c-.42,0-.75-.38-.68-.79l3-19.47c.05-.34.34-.58.68-.58h43.96c.33,0,.61.23.68.55l4.15,20.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M141.06,104.7l-41.34-68.37c-.65-1.07-2.29-.61-2.29.64v60.97c2.56.73,4.43,3.08,4.43,5.87,0,3.38-2.74,6.11-6.11,6.11s-6.11-2.74-6.11-6.11c0-2.84,1.95-5.23,4.58-5.91v-61.12c0-1.23-1.61-1.7-2.27-.67l-44.55,69.13c-.22.34-.26.76-.1,1.14l24.36,59.39c.19.46.64.77,1.14.77h43.4c.51,0,.96-.31,1.15-.78l23.82-59.96c.14-.36.11-.76-.09-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M29.19,32.28s59.39-59.38,133.62,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.29,33.8c0,2.14-1.74,3.88-3.88,3.88s-3.88-1.74-3.88-3.88,1.74-3.88,3.88-3.88,3.88,1.74,3.88,3.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 162.81,
    cy: 33.8,
    r: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 92.72,
    y: 2.6,
    width: 6.57,
    height: 6.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.83,257.2c23.75,19,44.97,18.02,58.59,13.84,14.79-4.54,24.08-13.7,24.17-13.79l.88.89c-.09.09-9.57,9.45-24.64,14.09-13.92,4.28-35.59,5.32-59.79-14.04l.78-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.73,256.74c0-1.34,1.09-2.43,2.43-2.43s2.43,1.09,2.43,2.43-1.09,2.43-2.43,2.43-2.43-1.09-2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M47.01,256.74c0-1.34,1.09-2.43,2.43-2.43s2.43,1.09,2.43,2.43-1.09,2.43-2.43,2.43-2.43-1.09-2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 89.19,
    y: 272.14,
    width: 4.11,
    height: 4.11,
    transform: "translate(182.48 548.4) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M371.92,99.93c-15.95-12.76-30.2-12.1-39.34-9.29-9.93,3.05-16.17,9.2-16.23,9.26l-.59-.59c.06-.06,6.43-6.35,16.55-9.46,9.35-2.88,23.9-3.57,40.15,9.43l-.53.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 315.29,
    cy: 100.24,
    r: 1.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 372.18,
    cy: 100.24,
    r: 1.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 342.73,
    y: 87.13,
    width: 2.76,
    height: 2.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.05,100.42l-13.62,2.79c-.11.02-.22-.06-.22-.17l-.26-5.28c0-.09.06-.17.15-.19l11.56-2.36c.09-.02.17.03.21.11l2.18,5.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.44,75.86l-14.55-15.76c-.23-.25-.64-.04-.57.29l3.28,16.04c.71.05,1.33.57,1.48,1.31.18.89-.39,1.75-1.28,1.94-.89.18-1.75-.39-1.94-1.28-.15-.75.23-1.48.89-1.8l-3.29-16.07c-.07-.32-.51-.36-.63-.05l-8,20.58c-.04.1-.03.21.03.3l9.6,14.31c.07.11.21.17.34.14l11.41-2.33c.13-.03.24-.13.26-.27l3.04-17.05c.02-.1-.01-.21-.08-.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 170.09,
    y: 100.91,
    width: 14.08,
    height: 70.09,
    transform: "translate(-23.65 38.25) rotate(-11.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 184.5,
    y: 80.88,
    width: 14.08,
    height: 70.09,
    transform: "translate(-3.02 5.15) rotate(-1.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.65,80.92l-13.89.37c-.11,0-.2-.1-.19-.21l.67-5.25c.01-.09.09-.16.18-.16l11.8-.31c.09,0,.17.06.19.14l1.26,5.42s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.31,56.8l-11.58-18.05c-.18-.28-.62-.15-.61.19l.44,16.36c.69.18,1.21.8,1.23,1.54.02.91-.69,1.66-1.6,1.68-.91.02-1.66-.69-1.68-1.6-.02-.76.48-1.42,1.19-1.62l-.44-16.4c0-.33-.44-.45-.61-.16l-11.46,18.87c-.06.09-.06.21-.02.31l6.96,15.76c.05.12.18.2.31.2l11.65-.31c.14,0,.26-.09.3-.22l5.96-16.26c.04-.1.02-.21-.03-.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.6 99.53 207.9 96.13 209.31 90.39 222.89 93.92 221.6 99.53 221.6 99.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 199.34,
    y: 96.6,
    width: 14.08,
    height: 70.09,
    transform: "translate(37.74 -45.79) rotate(13.92)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.79 91.77 225.26 81.04 221.4 67.79 212.78 77.97 210.15 88.62 222.79 91.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 216.42,
    y1: 73.62,
    x2: 223.56,
    y2: 75.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.36,145.02h58.37c1.84,0,3.34,1.5,3.34,3.34v64.76c0,14-11.37,25.37-25.37,25.37h-15.18c-13.5,0-24.46-10.96-24.46-24.46v-65.71c0-1.82,1.48-3.29,3.29-3.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 158.06,
    y: 155.09,
    width: 65.01,
    height: 8.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 158.06,
    y: 169.54,
    width: 65.01,
    height: 8.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 344.28,
    y1: 135.96,
    x2: 344.28,
    y2: 274.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 361.76,
    y1: 259.33,
    x2: 170,
    y2: 259.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311.37,250.2l-1.14-3.34c-.75-2.2-2.48-3.93-4.68-4.68l-3.34-1.14,3.41-1.24c2.1-.77,3.75-2.42,4.52-4.52l1.24-3.41.87,2.73c.84,2.65,2.92,4.72,5.56,5.56l2.73.87-2.81,1.11c-2.4.95-4.09,1.71-5.25,5.25l-1.11,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M369.28,171.66l-.75-2.19c-.49-1.44-1.63-2.58-3.07-3.07l-2.19-.75,2.23-.81c1.38-.5,2.46-1.59,2.96-2.96l.81-2.23.57,1.79c.55,1.73,1.91,3.09,3.64,3.64l1.79.57-1.84.73c-1.57.62-2.68,1.12-3.44,3.44l-.73,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M285.8,253.46c-2.57,0-4.66-2.09-4.66-4.66s2.09-4.66,4.66-4.66,4.66,2.09,4.66,4.66-2.09,4.66-4.66,4.66ZM285.8,245.54c-1.8,0-3.26,1.46-3.26,3.26s1.46,3.26,3.26,3.26,3.26-1.46,3.26-3.26-1.46-3.26-3.26-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M375.25,143.63c-1.14,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06,2.06.92,2.06,2.06-.92,2.06-2.06,2.06ZM375.25,140.13c-.79,0-1.44.65-1.44,1.44s.65,1.44,1.44,1.44,1.44-.65,1.44-1.44-.65-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M231.24,241.99c-1.14,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06,2.06.92,2.06,2.06-.92,2.06-2.06,2.06ZM231.24,238.49c-.79,0-1.44.65-1.44,1.44s.65,1.44,1.44,1.44,1.44-.65,1.44-1.44-.65-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M177.52,18.34l-1.14-3.34c-.75-2.2-2.48-3.93-4.68-4.68l-3.34-1.14,3.41-1.24c2.1-.77,3.76-2.42,4.52-4.52l1.24-3.41.87,2.73c.84,2.65,2.92,4.72,5.56,5.56l2.73.87-2.81,1.11c-2.4.95-4.09,1.71-5.25,5.25l-1.11,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.17,116.92l-1.14-3.34c-.75-2.2-2.48-3.93-4.68-4.68l-3.34-1.14,3.41-1.24c2.1-.77,3.76-2.42,4.52-4.52l1.24-3.41.87,2.73c.84,2.65,2.92,4.72,5.56,5.56l2.73.87-2.81,1.11c-2.4.95-4.09,1.71-5.25,5.25l-1.11,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M71.1,252.77l-.8-2.34c-.53-1.54-1.74-2.75-3.28-3.28l-2.34-.8,2.39-.87c1.47-.54,2.63-1.7,3.17-3.17l.87-2.39.61,1.92c.59,1.85,2.04,3.31,3.9,3.9l1.92.61-1.97.78c-1.68.66-2.87,1.2-3.68,3.68l-.78,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M198.66,29.92c-2.57,0-4.66-2.09-4.66-4.66s2.09-4.66,4.66-4.66,4.66,2.09,4.66,4.66-2.09,4.66-4.66,4.66ZM198.66,21.99c-1.8,0-3.26,1.46-3.26,3.26s1.46,3.26,3.26,3.26,3.26-1.46,3.26-3.26-1.46-3.26-3.26-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M27.41,210.25c-2.57,0-4.66-2.09-4.66-4.66s2.09-4.66,4.66-4.66,4.66,2.09,4.66,4.66-2.09,4.66-4.66,4.66ZM27.41,202.32c-1.8,0-3.26,1.46-3.26,3.26s1.46,3.26,3.26,3.26,3.26-1.46,3.26-3.26-1.46-3.26-3.26-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M89.18,244.33c-1.14,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06,2.06.92,2.06,2.06-.92,2.06-2.06,2.06ZM89.18,240.83c-.79,0-1.44.65-1.44,1.44s.65,1.44,1.44,1.44,1.44-.65,1.44-1.44-.65-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M67.33,37.92c-1.13,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06,2.06.92,2.06,2.06-.92,2.06-2.06,2.06ZM67.33,34.42c-.79,0-1.44.65-1.44,1.44s.65,1.44,1.44,1.44,1.44-.65,1.44-1.44-.65-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M201.6,4.66c-1.14,0-2.06-.92-2.06-2.06s.92-2.06,2.06-2.06,2.06.92,2.06,2.06-.92,2.06-2.06,2.06ZM201.6,1.16c-.79,0-1.44.65-1.44,1.44s.65,1.44,1.44,1.44,1.44-.65,1.44-1.44-.65-1.44-1.44-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M24.87,132.51c-2.57,0-4.66-2.09-4.66-4.66s2.09-4.66,4.66-4.66,4.66,2.09,4.66,4.66-2.09,4.66-4.66,4.66ZM24.87,124.58c-1.8,0-3.26,1.46-3.26,3.26s1.46,3.26,3.26,3.26,3.26-1.46,3.26-3.26-1.46-3.26-3.26-3.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.321443198456481596bfafee3db82fc7.svg";
export { ForwardRef as ReactComponent };